export default __webpack_public_path__ + "static/media/emptyOff.1712ecd5.svg";